/** @jsxImportSource @emotion/react */

import UserLayoutBanner from "assets/desktop/images/user-layout-banner.png";
import Container from "components/common/Container";
import { Outlet } from "react-router-dom";

import { UserLayoutStyle } from "./index.style";
import Sider from "./Sider";

export const UserLayout = () => {
  return (
    <div css={UserLayoutStyle.self}>
      <div css={UserLayoutStyle.banner}>
        <img src={UserLayoutBanner} alt="" />
      </div>
      <div css={UserLayoutStyle.contentWrapper}>
        <Container>
          <main css={UserLayoutStyle.mainContent}>
            <Sider />
            <div css={UserLayoutStyle.outlet}>
              <Outlet />
            </div>
          </main>
        </Container>
      </div>
    </div>
  );
};
